var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ active: _vm.$router.history.current.path === _vm.route }},[_c('a',{on:{"click":function($event){return _vm.toggleRoute()}}},[_c('Icon',{staticStyle:{"font-size":"18px"},attrs:{"icon":_vm.icon}}),_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }